import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@newfront-insurance/core-ui/v2';

export function ArchiveNovaScheduleDialog({
  open,
  scheduleTitle,
  isArchiving,
  error,
  onOpenChange,
  onConfirm,
}: {
  open: boolean;
  scheduleTitle: string;
  isArchiving: boolean;
  error?: unknown;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[380px] max-w-[calc(100vw-32px)]">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete schedule?</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          Nova will stop running <span className="font-semibold text-[#262D46]">{scheduleTitle}</span>. Existing chat
          deliveries will remain available.
        </AlertDialogDescription>
        {error ? (
          <p className="text-[13px] leading-5 text-[#C5342A]">Unable to delete this schedule. Try again.</p>
        ) : null}
        <AlertDialogFooter className="flex-row justify-end">
          <AlertDialogCancel disabled={isArchiving}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            variant="dangerous"
            disabled={isArchiving}
            onClick={(event) => {
              event.preventDefault();
              onConfirm();
            }}
          >
            {isArchiving ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
